import { TestLocators } from 'constants/Locators';

import { MUI } from 'ci-esi-web-shared';
import { ReactElement } from 'react';

export interface DefaultLayoutProps {
  children: ReactElement;
  testId?: TestLocators;
}

export function DefaultLayout({ children, testId }: DefaultLayoutProps) {
  return (
    <main>
      <MUI.Container maxWidth={false} data-testid={testId}>
        {children}
      </MUI.Container>
    </main>
  );
}
